import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import PhotoWell from '../components/photoWell';
import { Modal } from '../components/rich';
import { Typography, Button } from '../components/base';
import Icon, { ICON_TYPE } from '../components/base/icon';

const PhotoWellContext = createContext();

export const PhotoWellContextProvider = props => {
  const [isVisible, setIsVisible] = useState(props.isVisible);

  const [params, setParams] = useState({});

  const show = (p = {}) => {
    setIsVisible(true);
    setParams(p);
  };

  const hide = () => {
    setIsVisible(false);
    setParams({});
  };

  return (
    <PhotoWellContext.Provider
      value={{
        show,
        hide,
      }}
    >
      {props.children}

      {isVisible && (
        <Modal size="large" position="start" visible>
          <Modal.Header>
            <Typography.Heading size={3}>Your Photos</Typography.Heading>
            <Button variant="secondary" onClick={hide}>
              <Icon type={ICON_TYPE.CLOSE} width={18} height={18} mr={0} /> Close
            </Button>
          </Modal.Header>
          <Modal.Body>
            <PhotoWell id={props.id} {...params} pages={props.item.pages} sortable={false} />
          </Modal.Body>
        </Modal>
      )}
    </PhotoWellContext.Provider>
  );
};

PhotoWellContextProvider.propTypes = {
  id: PropTypes.string.isRequired,
  item: PropTypes.object,
  isVisible: PropTypes.bool,
  children: PropTypes.node,
};

PhotoWellContextProvider.defaultProps = {
  item: {},
  isVisible: false,
};

const usePhotoWellContext = () => {
  return useContext(PhotoWellContext);
};

export default usePhotoWellContext;
